import React from 'react';
import { useMutation } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { useHistory, useParams } from 'react-router-dom';
import ProjectHeader from '../../ProjectHeader';
import BudgetForm from '../components/BudgetForm';
import BudgetHeaderCotent from '../components/BudgetHeaderCotent';
import { ADD_BUDGET, GET_BUDGETS, GET_BUDGETS_PROJECT_INFO } from 'gql/budgets';
import { message } from 'antd';
import { useLoading } from 'hooks';

const AddBudget = () => {
  const { projectId } = useParams();
  const history = useHistory();
  const [addBudget, { loading }] = useMutation(ADD_BUDGET, {
    refetchQueries: [
      {
        query: GET_BUDGETS,
        variables: {
          projectIds: [projectId],
        },
      },
      {
        query: GET_BUDGETS_PROJECT_INFO,
        variables: {
          projectIds: [projectId],
          status: 'ALL',
        },
      },
    ],
    onCompleted: ({ addBudget }) => {
      message.success(
        `Budget ${addBudget.budgetCategory.name} successfully added`
      );
      history.push(`/projects/${projectId}/budget-virement`);
    },
    onError: (error) => {
      console.log({ error });
    },
  });
  useLoading(loading);

  const onFinish = (values) => {
    const {
      budgetCategory,
      approvedFunding,
      additionalFunding,
      remarks,
    } = values;
    addBudget({
      variables: {
        input: {
          projectId,
          budgetCategory,
          approvedFunding,
          additionalFunding,
          remarks,
        },
      },
    });
  };

  return (
    <ProjectHeader>
      <PageContainer
        header={{ title: 'Add Budget' }}
        ghost
        style={{ marginBottom: '32px' }}
        content={<BudgetHeaderCotent />}
      >
        <BudgetForm onFinish={onFinish} />
      </PageContainer>
    </ProjectHeader>
  );
};

export default AddBudget;
